import React, { useState, useEffect } from "react";
import "./MobileCoinAllotmentList.css";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Spinner from "../../Component/Spinner/Spinner";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import MobileCoinAllotHeader from "./MobileCoinAllotmentHeader/MobileCoinAllotHeader";
import MobileDeletePopup from "../../Component/MobileDeletePopup/MobileDeletePopup";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";
import MobileEditCoinOverlay from "./MobileEditCoinAllotOverlay/MobileEditCoinOverlay";
import MobileCoinAllotmentOverlay from "./MobileCoinAllotmentOverlay";

const MobileCoinAllotmentList = () => {
  const [globalSearch, setGlobalSearch] = useState("");
  const [columnSearch, setColumnSearch] = useState({
    transactionNo: "",
    datetime: "",
    customer: "",
    coins: "",
    transactionremarks: "",
    user: "",
    status: "active", 
    type: "",
  });
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({ net: 0 }); 
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCoinAllot, setEditCoinAllot] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [showAddOverlay, setShowAddOverlay] = useState(false);

  const navigate = useNavigate();
  const limit = 20;

  const fetchCoinAllotments = async (pageNum = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/");
        return;
      }

      const startfrom = (pageNum - 1) * limit;
      const payload = {
        startfrom,
        limit,
        custName: columnSearch.customer || "",
        status:
          columnSearch.status === "active"
            ? "ACTIVE"
            : columnSearch.status === "deactive"
              ? "Deactive"
              : "",
      };

      const res = await axios.post(Api.getCoinAllot, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status === 1 && Array.isArray(res.data.data)) {
        const allotments = res.data.data.map((item) => ({
          id: item._id,
          transactionNo: item.TransNo || "N/A",
          customer: item.CustName,
          coins: item.TransValue,
          TransType: item.TransType,
          transactionremarks: item.TransDesc,
          datetime: item.TransDate
            ? formatIndianDate(new Date(item.TransDate))
            : "",
          user: item.CreatedByAdminName,
          status: item.Status,
        }));

        const totalCoins = allotments.reduce((sum, item) => {
          if (item.TransType === "IN") return sum + Number(item.coins || 0);
          if (item.TransType === "OUT") return sum - Number(item.coins || 0);
          return sum;
        }, 0);

        setTotals({ net: totalCoins }); 

        setData((prev) =>
          pageNum === 1 ? allotments : [...prev, ...allotments]
        );

        setHasMore(allotments.length >= limit);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to fetch records.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchCoinAllotments(1);
  }, []);

  useEffect(() => {
    fetchCoinAllotments(1);
    setPage(1);
  }, [columnSearch.status]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setColumnSearch((prev) => ({
        ...prev,
        customer: globalSearch,
      }));
      fetchCoinAllotments(1);
      setPage(1);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [globalSearch]);

  const handleEditClick = (row) => {
    setEditCoinAllot(row);
    setShowEditModal(true);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(
        Api.editCoinAllot,
        { _id: selectedId, Status: "Deactive" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPopup({
        show: true,
        message: "Record deactivated successfully!",
        type: "success",
      });
      setData((prev) => prev.filter((item) => item.id !== selectedId));
    } catch (err) {
      setPopup({
        show: true,
        message: "Failed to deactivate record.",
        type: "error",
      });
    } finally {
      setShowDeleteModal(false);
      setSelectedId(null);
    }
  };

  return (
    <div className="mobile-product-main-wrapper">

      <div className="mobile-coinallotment-page">
        <MobileCoinAllotHeader
          search={globalSearch}
          setSearch={setGlobalSearch}
          columnSearch={columnSearch}
          setColumnSearch={setColumnSearch}
          totals={totals}
        />

        <div id="coin-scrollableDiv" className="coin-scrollable">
          {loading && page === 1 ? (
            <Spinner />
          ) : data.length > 0 ? (
            <InfiniteScroll
              dataLength={data.length}
              next={() => {
                const nextPage = page + 1;
                setPage(nextPage);
                fetchCoinAllotments(nextPage);
              }}
              hasMore={hasMore}
              loader={<Spinner />}
              scrollableTarget="coin-scrollableDiv"
            >
              {data.map((row) => (
                <div
                  className={`coin-card ${row.status === "ACTIVE" ? "active" : "deactive"
                    }`}
                  key={row.id}
                >
                  <div className="coin-card-top">
                    <div className="coin-info">
                      <h4 className="coin-title">{row.customer}</h4>

                      <p className="coin-company">{row.user}</p>
                    </div>

                    <div
                      className={`coin-pill ${row.TransType === "IN" ? "positive" : "negative"
                        }`}
                    >
                      {row.TransType === "IN"
                        ? `+${row.coins}`
                        : `-${row.coins}`}
                    </div>
                  </div>

                  <div className="coin-card-bottom">
                    <span className="coin-date">{row.datetime}</span>
                    <div className="coin-actions">
                      <FaEdit
                        className="edit-icon"
                        onClick={() => handleEditClick(row)}
                      />
                      <FaTrash
                        className="delete-icon"
                        onClick={() => handleDeleteClick(row.id)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          ) : (
            <div className="mobile-no-data">No records found</div>
          )}
        </div>

        {!showEditModal && (
          <button
            className={`floating-add-btn ${showAddOverlay || showEditModal ? "blur" : ""}`}
            onClick={() => setShowAddOverlay(true)}
          >
            <FaPlus />
          </button>

        )}

        {showAddOverlay && (
          <MobileCoinAllotmentOverlay
            onClose={() => setShowAddOverlay(false)}
            onSave={() => fetchCoinAllotments(0)}
          />
        )}

        {showEditModal && (
          <MobileEditCoinOverlay
            coinData={editCoinAllot}
            onClose={() => setShowEditModal(false)}
            onSave={() => fetchCoinAllotments(1)}
          />
        )}

        <MobileDeletePopup
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
        />

        <MobileConfirmPopup
          show={popup.show}
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ ...popup, show: false })}
        />
      </div>
    </div>
  );
};

export default MobileCoinAllotmentList;
